import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Error404 = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">404</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
        La page que vous recherchez est introuvable.
        </p>
        <hr />
        <p>
        Assurez-vous que l'adresse est correcte et que la page n'a pas bougé. Si
          tu penses que c'est une erreur,
          <a href="mailto:contact@omarsoft.fr" className="ms-1">
            contactez-nous
          </a>
          .
        </p>
        <Link className="btn btn-primary btn-sm mt-3" to="/">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Ramène-moi à la l'accueil
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Error404;
